import { LinearProgress } from "@mui/material";

import GeneralErrorAlert from "@/common/components/AppAlerts/GeneralErrorAlert";
import RolesSelector, { RolesSelectorProps } from "@/common/components/Entity/Role/RolesSelector";
import { useApiRequest } from "@/common/hooks/api/useApiRequest";
import { apiClient } from "@/core/api/ApiClient";

export interface TenantRolesSelectorProps extends Omit<
  RolesSelectorProps,
  "getRoles" | "roleList" | "roleAssignmentRestrictions"
> {
  tenantId: string | null | undefined;
  targetUserId?: string | null | undefined;
}

export default function AdminTenantRolesSelector({
  tenantId,
  targetUserId,
  ...otherProps
}: TenantRolesSelectorProps) {
  const roleAssignmentRestrictionsRequest = useApiRequest(
    apiClient.accountAdminApi.apiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGet,
    {
      tenantId: tenantId || "",
      targetUserId: targetUserId || undefined,
    },
    {
      deps: [tenantId, targetUserId],
      skip: !tenantId,
    },
  );
  const roleAssignmentRestrictions = roleAssignmentRestrictionsRequest?.data;

  if (roleAssignmentRestrictionsRequest.isLoading) {
    return <LinearProgress />;
  }
  if (roleAssignmentRestrictionsRequest.isError) {
    return <GeneralErrorAlert title='Error while loading roles' />;
  }

  return (
    <RolesSelector
      getRoles={async () => {
        if (!tenantId) {
          return [];
        }
        const response = await apiClient.accountAdminApi.apiV1AdminAccountTenantsTenantIdRolesGet({
          tenantId: tenantId,
        });
        return response.data;
      }}
      roleAssignmentRestrictions={roleAssignmentRestrictions}
      {...otherProps}
    />
  );
}
